const PLATFORMS = require('./integrationPlatforms')
module.exports = [
  // {
  //   platform: PLATFORMS.MESSENGER,
  //   title: 'Square',
  //   logo: '/img/square.logo.svg',
  //   description:
  //     'Boost Square Loyalty with the Messenger integration, customer reviews, feedback and much more with this integration.',
  //   soon: true
  // },
  {
    platform: PLATFORMS.PACT,
    title: 'Pact',
    component: 'Pact',
    logo: 'https://cdn.prod.website-files.com/5ed912d71402d2248ce479b7/5ed912d71402d26e76e47a2d_v2.svg',
    description: 'Integrate WhatsApp with help of Pact'
  }
]
